/** Number column text for an invoice/quotation that has not been issued yet. */
export const UNNUMBERED_DRAFT_LABEL = 'Draft (unnumbered)';

export const documentNumberLabel = (num: string | null | undefined): string => num || UNNUMBERED_DRAFT_LABEL;

/** Balance due: a voided invoice owes nothing, whatever its original totals were. */
export const invoiceBalanceDue = (
  inv: { status: string; totalAmount: number; paidAmount: number; creditedAmount?: number },
): number => (inv.status === 'VOIDED' ? 0 : inv.totalAmount - inv.paidAmount - (inv.creditedAmount ?? 0));

/**
 * Status label for an invoice. The stored PARTIALLY_PAID also covers "reduced by a credit note", so a part-settled
 * invoice with nothing actually paid reads "Partially credited". The stored enum is unchanged.
 */
export const invoiceStatusLabel = (
  inv: { status: string; paidAmount?: number; creditedAmount?: number },
  humanize: (v: string) => string,
): string => (inv.status === 'PARTIALLY_PAID' && !(inv.paidAmount && inv.paidAmount > 0.004)
  && (inv.creditedAmount ?? 0) > 0.004 ? 'Partially credited' : humanize(inv.status));
